import { withStyles } from '@material-ui/core/styles';
import ViewWrapper from 'views/ViewWrapper';
import MuiGrid from '@material-ui/core/Grid';
import MuiPaper from '@material-ui/core/Paper';
import MuiTypography from '@material-ui/core/Typography';
import AvailableQueries from './available-queries';
import PromptBuilder from './prompt-builder';

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
});

const QueryLibrary = ({ ...props }) => {
  const { classes } = props;

  return (
    <ViewWrapper>
      <MuiGrid item xs={12}>
        <MuiPaper className={classes.paper}>
          <MuiTypography className={classes.title} variant="h5">
            Query Library
          </MuiTypography>
          <AvailableQueries />
          <PromptBuilder />
        </MuiPaper>
      </MuiGrid>
    </ViewWrapper>
  );
};

export default withStyles(styles)(QueryLibrary);
